import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import Num2persian from 'num2persian';
import { GetEnumValuesDto } from './../api/models/get-enum-values-dto';
import { AppConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor() {}

  static removeEmpty(obj: object): any {
    function cleanUpObject(jsonObject: object): any {
      if (jsonObject) {
        Object.keys(jsonObject).forEach(function (key, index) {
          const currentObj = jsonObject[key];

          if (
            _.isNull(currentObj) ||
            Number.isNaN(jsonObject[key]) ||
            jsonObject[key] == 'NaN'
          ) {
            delete jsonObject[key];
          } else if (_.isObject(currentObj)) {
            if (_.isArray(currentObj)) {
              if (
                !currentObj.length ||
                Number.isNaN(jsonObject[key]) ||
                jsonObject[key] == 'NaN'
              )
                delete jsonObject[key];
              else {
                const cleanupArrayObj = [];
                for (const obj of currentObj) {
                  if (!_.isNull(obj)) {
                    const cleanObj = cleanUpObject(obj);
                    if (!_.isEmpty(cleanObj) || !isNaN(cleanObj)) {
                      cleanupArrayObj.push(cleanObj);
                    }
                  }
                }
                if (
                  !cleanupArrayObj.length ||
                  Number.isNaN(jsonObject[key]) ||
                  jsonObject[key] == 'NaN'
                )
                  delete jsonObject[key];
                else {
                  jsonObject[key] = cleanupArrayObj;
                }
              }
            } else {
              if (
                _.isEmpty(Object.keys(jsonObject[key])) ||
                Number.isNaN(jsonObject[key]) ||
                jsonObject[key] == 'NaN'
              )
                delete jsonObject[key];
              else {
                jsonObject[key] = cleanUpObject(currentObj);

                if (
                  _.isEmpty(Object.keys(jsonObject[key])) ||
                  Number.isNaN(jsonObject[key]) ||
                  jsonObject[key] == 'NaN'
                )
                  delete jsonObject[key];
              }
            }
          }
        }, jsonObject);
        return jsonObject;
      } else if ((jsonObject as any) == 0) return jsonObject;
    }
    return cleanUpObject(obj);
  }

  static deepRemovePropFormObject(obj: any, keyToDelete: string) {
    function deepUnset(obj, keyToDelete) {
      if (_.isArray(obj)) obj.forEach((item) => deepUnset(item, keyToDelete));
      else if (_.isObject(obj)) {
        _.forOwn(obj, (value, key) => {
          if (key === keyToDelete) _.unset(obj, key);
          else deepUnset(value, keyToDelete);
        });
      }
    }
    const newObj = JSON.parse(JSON.stringify(obj));
    deepUnset(newObj, keyToDelete);
    return newObj;
  }

  static enumToKeyValueList(_enum: object): GetEnumValuesDto[] {
    let array = <GetEnumValuesDto[]>Object.entries(_enum).map(
      ([key, value]) => {
        return {
          key: +key,
          value: value,
        };
      }
    );

    return array.splice(0, array.length / 2);
  }

  static downloadFile(fileUrl, addApiUrlToFirstLink: boolean = true) {
    let downloadLink;

    if (addApiUrlToFirstLink)
      downloadLink = AppConfigService.config.apiUrl + '/' + fileUrl;
    else downloadLink = fileUrl;

    const link = document.createElement('a');
    document.body.appendChild(link);
    link.setAttribute('download', '');
    link.setAttribute('target', '_blank');
    link.href = downloadLink;
    link.click();
  }

  static async getDownloadedFile(patch, addApiUrlToFirstLink: boolean = true) {
    let url;

    if (addApiUrlToFirstLink)
      url = AppConfigService.config.apiUrl + '/' + patch;
    else url = patch;

    const data = await fetch(url, { mode: 'no-cors' });
    const blob = await data.blob();

    return blob;
  }

  static num2persian(number): string {
    number = Math.trunc(+number / 10);
    return Num2persian(number);
  }

  /**
   *Create array from number
   */
  static getRange(num: number): number[] {
    return [...Array(num).keys()];
  }

  static unicodeToChar(text: string): string {
    return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    });
  }
}
